define(['jquery'], function($) {
    var instance = {
        getStoredItem: function (storedObjId, jsonParse) {
            var storedObj = localStorage.getItem(storedObjId);

            return jsonParse ? $.parseJSON(storedObj) : storedObj;
        },
        setStoredItem: function (storedObjId, storedObj, jsonStringify) {
            var objToStore = jsonStringify ? JSON.stringify(storedObj) : storedObj;
            localStorage.setItem(storedObjId, objToStore);
        }
    };

    return instance;
});